import React, { ChangeEvent, useState } from 'react';

import { Checkbox, LbFormControlLabel } from '@infoods/lifebase-ui';
import { observer } from 'mobx-react';

import classes from './CheckoutForm.module.scss';
import { StripePaymentForm } from '../../../components/checkout/StripePaymentForm/StripePaymentForm';
import { TermsLinks } from '../../../../shared/components/TermsLinks/TermsLinks';
import { getPriceView } from '../../../../shared/utils/stringUtils';
import { getRouteParam } from '../../../../shared/utils/angularUtils';
import { generatePaymentResultUrl } from '../../../utils/generatePaymentResultUrl/generatePaymentResultUrl';
import { checkoutStore } from '../../../stores/checkoutStore';
import { checkoutQueryParams } from '../../../constants/pathQueryParams';
import { SOLUTION_TYPE } from '../../../../shared/constants/user-info/solutionType';
import { SUBSCRIPTION } from '../../../../shared/constants/user-info/subscription';

const CheckoutForm = observer(() => {
  const [termsAccepted, setTermsAccepted] = useState(false);

  const retryPath = getRouteParam(checkoutQueryParams.retryPath);
  const paymentResultType = getRouteParam(checkoutQueryParams.paymentResultType);
  const consultationType = getRouteParam(checkoutQueryParams.consultationType);
  const entityId = getRouteParam(checkoutQueryParams.entityId);
  const challengeId = getRouteParam(checkoutQueryParams.challengeId);

  const { checkoutInfo, subscriptionTypeFlags, billingPeriodTypeFlags } = checkoutStore;

  if (!checkoutInfo) {
    return null;
  }

  const { paymentIntent, checkoutDetails, subscription } = checkoutInfo;

  const solution =
    subscription.subscriptionType === SUBSCRIPTION.SCAN_IQ
      ? SOLUTION_TYPE.SCAN_IQ
      : SOLUTION_TYPE.NUTRITION;

  const returnUrl = generatePaymentResultUrl(solution, {
    retryPath,
    paymentResultType,
    connectedAccountId: paymentIntent.connectedAccountId,
    consultationType,
    entityId,
    challengeId,
  });

  const handleChangeTermsAccepted = (
    event: ChangeEvent<HTMLInputElement>,
    checked: boolean,
  ) => {
    setTermsAccepted(checked);
  };

  const getTermsAcceptedLabel = () => {
    if (subscriptionTypeFlags.REGULAR) {
      return `I understand that this is a recurring subscription and I'm going to be billed ${getPriceView(
        subscription.monthlyRenewalPriceFinal,
      )} amount next month (plus taxes) after initial plan ends`;
    }

    if (subscriptionTypeFlags.SCAN_IQ) {
      return 'I understand that I will be billed according to the payment type/subscription that I chose. Subscriptions are recurring and I will be billed until I notify this InBody testing location of my intent to cancel said subscription.';
    }

    return `I understand that this is a recurring subscription and I'm going to be billed ${getPriceView(
      subscription.monthlyRenewalPriceFinal,
    )} amount next month (plus taxes)`;
  };

  const paymentButtonProps = {
    returnUrl,
    label: subscription.name,
    totalAmount: checkoutDetails.totalAmount,
    clientSecret: paymentIntent.clientSecret,
  };

  return (
    <StripePaymentForm
      paymentButtonProps={paymentButtonProps}
      submitDisabled={!termsAccepted && !billingPeriodTypeFlags.DAILY}
    >
      <div className={classes.terms}>
        {!billingPeriodTypeFlags.DAILY && (
          <LbFormControlLabel
            align="start"
            control={
              <Checkbox
                checked={termsAccepted}
                onChange={handleChangeTermsAccepted}
                color="primary"
                name="saveCard"
              />
            }
            label={getTermsAcceptedLabel()}
          />
        )}
        <TermsLinks />
      </div>
    </StripePaymentForm>
  );
});

export { CheckoutForm };
